// import React, { useState, useEffect } from 'react';
// import { Card, Alert, Button, Form, Image, Row, Col } from 'react-bootstrap';
// import { InfoCircle } from 'react-bootstrap-icons';
// import axios from 'axios';

// function CoverPhoto() {
//   const [dragActive, setDragActive] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [coverPhoto, setCoverPhoto] = useState(null);
//   const token = localStorage.getItem("jwttoken");

//   // Fetch user data (GET request)
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const response = await axios.get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const userCoverPhoto = response.data.cover_photo;
//         if (userCoverPhoto) {
//           const base64Image = `data:image/png;base64,${userCoverPhoto}`; // Add MIME type
//           setCoverPhoto(base64Image);
//           setPreview(base64Image);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//         alert('Failed to fetch user data.');
//       }
//     };

//     fetchUserData();
//   }, [token]);

//   // Handle drag events
//   const handleDrag = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(e.type === 'dragenter' || e.type === 'dragover');
//   };

//   // Handle file drop
//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       handleFileUpload(e.dataTransfer.files[0]);
//     }
//   };

//   // Handle file selection
//   const handleChange = (e) => {
//     if (e.target.files && e.target.files.length === 1) {
//       handleFileUpload(e.target.files[0]);
//     } else {
//       alert('Please select only one file.');
//     }
//   };

//   // Handle file upload and set preview
//   const handleFileUpload = (file) => {
//     setSelectedFile(file);
//     const filePreview = URL.createObjectURL(file);
//     setPreview(filePreview);

//     // Convert file to Base64
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64String = reader.result.split(',')[1]; // Extract Base64 string
//       setCoverPhoto(base64String);
//     };
//     reader.readAsDataURL(file);
//   };

//   // Handle save changes (PATCH request)
//   const handleSave = async () => {
//     if (coverPhoto) {
//       const data = {
//         cover_photo: coverPhoto, // Send the Base64 string
//       };

//       try {
//         const response = await axios.patch('https://kaasbackend.vetrinahealthcare.com/lms/user/', data, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json', // Sending Base64 as part of JSON payload
//           },
//         });

//         if (response.data.cover_photo) {
//           alert('Cover photo saved successfully!');
//         } else {
//           alert('Failed to save cover photo.');
//         }
//       } catch (error) {
//         console.error('Error saving cover photo:', error.response || error);
//         alert('Failed to save cover photo.');
//       }
//     } else {
//       alert('No file selected.');
//     }
//   };

//   // Handle delete cover photo
//   const handleDelete = async () => {
//     try {
//       await axios.patch(
//         'https://kaasbackend.vetrinahealthcare.com/lms/user/',
//         { cover_photo: null },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       setSelectedFile(null);
//       setPreview(null);
//       setCoverPhoto(null);
//       alert('Cover photo deleted successfully.');
//     } catch (error) {
//       console.error('Error deleting cover photo:', error);
//       alert('Failed to delete cover photo.');
//     }
//   };

//   return (
//     <Card className="mx-auto mt-4" style={{ maxWidth: '600px' }}>
//       <Card.Header>
//         <h4 className="text-center">Change Cover Photo</h4>
//       </Card.Header>
//       <Card.Body>
//         <Alert variant="info" className="d-flex align-items-center">
//           <InfoCircle className="me-2" />
//           <div>Your Cover Photo will be used to customize the header of your profile.</div>
//         </Alert>

//         <div
//           className={`border rounded p-4 text-center ${
//             dragActive ? 'border-primary bg-light' : 'border-secondary'
//           }`}
//           onDragEnter={handleDrag}
//           onDragLeave={handleDrag}
//           onDragOver={handleDrag}
//           onDrop={handleDrop}
//         >
//           {!preview ? (
//             <p className="mb-3">Drop your image here or click below to select a file</p>
//           ) : (
//             <Image src={preview} alt="Cover Preview" fluid className="mb-3 rounded preview-image" />
//           )}

//           <Form.Group controlId="file-upload" className="mb-3">
//             <Form.Label>
//               <Button variant="secondary" as="span">
//                 Select your file
//                 <Form.Control
//                   type="file"
//                   className="d-none"
//                   accept="image/*"
//                   onChange={handleChange}
//                 />
//               </Button>
//             </Form.Label>
//           </Form.Group>
//         </div>

//         <div className="bg-light p-3 rounded text-muted mt-3">
//           For best results, upload an image that is 1950px by 450px or larger.
//         </div>

//         <div className="mt-4">
//           <Row>
//             <Col xs={12} sm={6} className="mb-2">
//               <Button variant="success" onClick={handleSave} className="w-100" disabled={!selectedFile}>
//                 Save Changes
//               </Button>
//             </Col>
//             <Col xs={12} sm={6} className="mb-2">
//               <Button
//                 variant="danger"
//                 onClick={handleDelete}
//                 className="w-100"
//                 disabled={!coverPhoto}
//               >
//                 Delete My Cover Photo
//               </Button>
//             </Col>
//           </Row>
//         </div>
//       </Card.Body>
//     </Card>
//   );
// }

// export default CoverPhoto;

import React, { useState, useEffect } from 'react'
import { Card, Button, Form, Image, Row, Col } from 'react-bootstrap'
import { InfoCircle } from 'react-bootstrap-icons'
import axios from 'axios'
import Swal from 'sweetalert2'

function CoverPhoto() {
  const [dragActive, setDragActive] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [preview, setPreview] = useState(null)
  const [coverPhoto, setCoverPhoto] = useState(null)
  const token = localStorage.getItem('jwttoken')

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        const userCoverPhoto = response.data.cover_photo
        if (userCoverPhoto) {
          // Ensure the base64 image is correctly formatted
          setCoverPhoto(userCoverPhoto)
          setPreview(`data:image/png;base64,${userCoverPhoto}`)
        }
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          text: 'Failed to fetch user data.',
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }
    }

    fetchUserData()
  }, [token])

  const handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(e.type === 'dragenter' || e.type === 'dragover')
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0])
    }
  }

  const handleChange = (e) => {
    if (e.target.files && e.target.files.length === 1) {
      handleFileUpload(e.target.files[0])
    } else {
      Swal.fire({
        title: 'Warning!',
        text: 'Please select only one file.',
        icon: 'warning',
        confirmButtonText: 'OK',
      })
    }
  }

  const handleFileUpload = (file) => {
    setSelectedFile(file)
    const filePreview = URL.createObjectURL(file)
    setPreview(filePreview)

    const reader = new FileReader()
    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1]
      setCoverPhoto(`data:image/png;base64,${base64String}`) // Ensure correct format
    }
    reader.readAsDataURL(file)
  }

  const handleSave = async () => {
    if (coverPhoto) {
      const data = { cover_photo: coverPhoto.split(',')[1] } // Send only base64 data

      try {
        const response = await axios.patch(
          'https://kaasbackend.vetrinahealthcare.com/lms/user/',
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (response.data.cover_photo) {
          setPreview(`data:image/png;base64,${response.data.cover_photo}`) // Update preview on success
          Swal.fire({
            title: 'Success!',
            text: 'Cover photo saved successfully!',
            icon: 'success',
            confirmButtonText: 'OK',
          })
        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Failed to save cover photo.',
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          text: 'Failed to save cover photo.',
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }
    } else {
      Swal.fire({
        title: 'Warning!',
        text: 'No file selected.',
        icon: 'warning',
        confirmButtonText: 'OK',
      })
    }
  }

  const handleDelete = async () => {
    try {
      await axios.patch(
        'https://kaasbackend.vetrinahealthcare.com/lms/user/',
        { cover_photo: null },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setSelectedFile(null)
      setPreview(null)
      setCoverPhoto(null)
      Swal.fire({
        title: 'Success!',
        text: 'Cover photo deleted successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
      })
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to delete cover photo.',
        icon: 'error',
        confirmButtonText: 'OK',
      })
    }
  }

  return (
    <Card className='mx-auto mt-4' style={{ maxWidth: '600px' }}>
      <Card.Header>
        <h4 className='text-center'>Change Cover Photo</h4>
      </Card.Header>
      <Card.Body>
        <div
          className={`border rounded p-4 text-center ${
            dragActive ? 'border-primary bg-light' : 'border-secondary'
          }`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          {!preview ? (
            <p className='mb-3'>
              Drop your image here or click below to select a file
            </p>
          ) : (
            <Image
              src={preview}
              alt='Cover Preview'
              fluid
              className='mb-3 rounded preview-image'
            />
          )}

          <Form.Group controlId='file-upload' className='mb-3'>
            <Form.Label>
              <Button variant='secondary' as='span'>
                Select your file
                <Form.Control
                  type='file'
                  className='d-none'
                  accept='image/*'
                  onChange={handleChange}
                />
              </Button>
            </Form.Label>
          </Form.Group>
        </div>

        <div className='mt-4'>
          <Row>
            <Col xs={12} sm={6} className='mb-2'>
              <Button
                variant='success'
                onClick={handleSave}
                className='w-100'
                disabled={!selectedFile}
              >
                Save Changes
              </Button>
            </Col>
            <Col xs={12} sm={6} className='mb-2'>
              <Button
                variant='danger'
                onClick={handleDelete}
                className='w-100'
                disabled={!coverPhoto}
              >
                Delete My Cover Photo
              </Button>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  )
}

export default CoverPhoto
